import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";
export default class RTQ {
    // takes the Vuex context.
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.qeIdCount = 0;
        this.initQuoteRequest = '';
        this.processedQeIds = [];
        this.qeIdElems = {};
        this.rawRTQPremDtls = {};
        this.triggerPage = '';
    }

    pg_coverage_start(payload) {
        console.log('Business Logic for pg_coverage_start: ', payload);
        return;
    }

    quote(e, input) {
        console.log('rtq-service: quote.');
    }

    toggleQuoteDisplay(e, input) {
        console.log('rtq-service: toggleQuoteDisplay');

        const bUid = 'in_see_all_quotes';

        var text = 'Show Me All The Quotes';
        var val = 'filtered';
        var key = `${val}_quotes_uids`;
        if (input.value == 'filtered') {
            val = 'all';
            text = 'Filter The Quotes';
            key = `${val}_quotes_uids`;
        }
        const quids = this.ctx.getters.factory[key];
        const inSeqMaps = [
            {
                puid: 'pg_rtq',
                suid: 'sc_rtq',
                iseq: quids
            }
        ];
        console.log('rtq-service: UPDATE_INPUT_SEQS', inSeqMaps);

        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: bUid, key: 'value', val: val });
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: bUid, key: 'label', val: text });
        this.ctx.commit('UPDATE_RTQ_INPUT_SEQS', inSeqMaps);
    }

    getRatings(data) {
        const $rtq = this;
        const $fs = new Funnel({ ctx: this.ctx });
        const reqType = $fs.getReqType('pg_rtq');
        console.log('getRatings', reqType);
        const $endpoint = `/api?req=${reqType}&action=save-rtq`;

        this.qeIdCount = data.options.quote_count;
        this.initQuoteRequest = data.options.initQuoteRequest;
        this.triggerPage = data.trigger_page;

        $rtq.poll(data.options.quote_execution_ids, function (result) {
            if ($rtq.processedQeIds.length == $rtq.qeIdCount && $rtq.initQuoteRequest == reqType) {
                console.log('QeIdElems to commit: ', $rtq.qeIdElems);
                let elems = {}, iseq = [], ssIseq = [];
                for (const qid in $rtq.qeIdElems) {
                    for (const uid in $rtq.qeIdElems[qid].data.elems) {
                        const elem = $rtq.qeIdElems[qid].data.elems[uid];
                        elems[uid] = elem;
                        iseq.push(uid);
                    }
                    if (ssIseq.length == 0) {
                        ssIseq = $rtq.qeIdElems[qid].data.inSeqMaps[0].iseq;
                    }

                }
                console.log('Elems: ', elems);
                const diffUids = ssIseq.filter(function (i) { return iseq.indexOf(i) < 0; });
                iseq = iseq.concat(diffUids);

                //--- persisiting RTQ elems.
                const post = {
                    trigger_page: $rtq.triggerPage,
                    iuids: iseq,
                    premium_details: $rtq.rawRTQPremDtls
                }
                console.log('RTQ persist data: ', post);
                $.ajax({
                    type: 'POST',
                    url: $endpoint,
                    data: post,
                    beforeSend: function () { },
                    success: function (res) {
                        console.log('RTQ persist complete! ', res);

                        if (res.data && Object.keys(res.data).length > 0) {
                            $fs.commitMutations(res.data);
                        }
                        $fs.resetLoadingState();

                        $rtq.saveSuppressedQuotes();
                    },
                    error: function () { }
                });
            }
        });
    }

    poll(qeIDs, callback) {
        const $rtq = this;
        const $fs = new Funnel({ ctx: this.ctx });
        const reqType = $fs.getReqType('pg_rtq');
        var c = 0,
            endpoint = `/api?req=${reqType}&action=get-rtq-batch`,
            countLimit = rtqEnv.countLimit,
            qeIDStatus = {},
            timeoutThreshold = rtqEnv.timeoutThreshold,
            lastRequest = 0;

        async.doUntil(
            function (cb) {
                c++;
                lastRequest = Date.now()
                var errorCount = 0
                console.log(`This is a qeID: ${qeIDs} count: ${c}`);
                $.ajax({
                    type: 'POST',
                    url: `${endpoint}`,
                    data: { qeIDs: qeIDs },
                    success: function (results) {
                        for (const qeID of Object.keys(results)) {
                            let res = results[qeID]

                            console.log(`poll result for: ${qeID}`, res);

                            let status = res.result;
                            qeIDStatus[qeID] = status
                            if (res.rtq_vx) {
                                $rtq.qeIdElems[qeID] = res.rtq_vx;
                            }
                            if (res.raw_rtq) {
                                // console.log("Before "+ res.raw_rtq[qeID]) 
                                // Object.keys(res.raw_rtq[qeID].coverages).forEach((key)=>
                                //     coverages[key] === "Review in carrier" ? coverages[key] = "Review with Agent" : coverages[key]
                                // );  
                                // console.log("After "+ res.raw_rtq[qeID]) 
                                $rtq.rawRTQPremDtls[qeID] = res.raw_rtq[qeID];
                            }
                        }
                    },
                    error: function () {
                        errorCount++

                        if (errorCount <= 3) {
                            setTimeout(function () {
                                context.dispatch('getFunnel');
                            }, 3000)
                        }
                        else {
                            // Do something here
                        }
                    },
                    complete: function (res, status) {
                        let responseDiff = Date.now() - lastRequest
                        let timeout = 0;

                        console.log('responseDiff', responseDiff)

                        if (responseDiff <= timeoutThreshold) {
                            timeout = timeoutThreshold - responseDiff
                        }
                        console.log('timeout', timeout)

                        setTimeout(cb, timeout);
                    }
                });
                //setTimeout(cb, 3055);
            },
            function () {
                for (const qeID of Object.keys(qeIDStatus)) {
                    if (qeIDStatus[qeID] !== 'pending') {
                        const indx = qeIDs.indexOf(parseInt(qeID));
                        //console.log('qeIDs', qeIDs, qeID, indx)
                        if (indx !== -1) {
                            qeIDs.splice(indx, 1);
                        }
                    }
                }

                return (qeIDs.length === 0 || c > countLimit);
            },
            function (err) {
                for (let qeID of Object.keys(qeIDStatus)) {
                    let status = qeIDStatus[qeID]

                    if (status == 'success') {
                        console.log(`Completed successfully: ${qeID}`, $rtq.qeIdElems[qeID]);
                        $rtq.processedQeIds.push(qeID);
                        callback();
                    } else if (status == 'pending') {
                        if (c > countLimit) {
                            $rtq.processedQeIds.push(qeID);
                        }

                        callback({ msg: 'timed out' });
                    } else {
                        $rtq.processedQeIds.push(qeID);
                        callback({ msg: 'failed' });
                    }
                }
            }
        );
    }

    selectQuote(e, input) {
        const uid = 'in_selected_quote';
        const qUid = input.uid;
        const val = input.value;
        const elemName = `sq_${qUid}`;
        let post = {};
        post[uid] = {
            element_name: elemName,
            value: val
        };

        const quotes = this.ctx.getters.factory.quotes;
        if (!Utils.isObjEmpty(quotes) && !Utils.isObjEmpty(quotes[qUid])) {
            const selectedQuote = quotes[qUid];
            const slctQtBaseRoute = this.ctx.getters.funnel.elements['pg_rtq_success'].page_route;

            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: val });
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'element_name', val: elemName });
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'data', val: selectedQuote.data });
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'features', val: selectedQuote.features });

            this.ctx.dispatch('selectQuote', { payload: post });
            this.router.push(slctQtBaseRoute).catch(() => { });
        }
    }

    buyOnline(e, input) {
        console.log('buyOnline -: ', input);

        let post = {};
        post['in_buy_online_rtq'] = input;

        const quotes = this.ctx.getters.factory.quotes;
        if (!Utils.isObjEmpty(quotes) && !Utils.isObjEmpty(quotes[input.uid])) {
            this.ctx.dispatch('buyOnline', { payload: post });
        }
    }

    bridgeToCarrier(e, input) {
        var link = input.value;
        window.open(link, '_blank');
    }

    saveSuppressedQuotes() {
        console.log('saving suppressed quotes! ');

        const $rtq = this;
        const $fs = new Funnel({ ctx: this.ctx });
        const reqType = $fs.getReqType('pg_rtq');
        console.log('getRatings', reqType);
        const $endpoint = `/api?req=${reqType}&action=save-supressed-quotes`;

        const post = {
            trigger_page: $rtq.triggerPage
        }

        $.ajax({
            type: 'POST',
            url: $endpoint,
            data: post,
            beforeSend: function () { },
            success: function (res) {
                console.log('Quote suppression complete! ', res);
                /* if (res.data && Object.keys(res.data).length > 0) {
                    $fs.commitMutations(res.data);
                } */
            },
            error: function () { }
        });
    }

}
